/*global qq */
qq.version = "5.11.10-beta+1";
